// Stub: Lovable integration placeholder (no backend connected yet).
import { supabase } from "./supabase/client";

export const lovable = {
  isConfigured: false as const,
  auth: {
    async signInWithOAuth(
      provider: "google" | "apple" | string,
      options?: { redirect_uri?: string },
    ): Promise<{ error: { message?: string } | null; redirected?: boolean }> {
      try {
        const { error } = await supabase.auth.signInWithOAuth({
          provider: provider as "google" | "apple",
          options: { redirectTo: options?.redirect_uri },
        });
        if (error) return { error: { message: error.message }, redirected: false };
        return { error: null, redirected: true };
      } catch (e) {
        return { error: { message: (e as Error).message }, redirected: false };
      }
    },
  },
};